<template>
    <div class="flex gap-1.5 flex-col sm:p-2 h-dvh w-screen">
        <div
            class="relative flex flex-col sm:flex-row sm:gap-1 h-full w-full sm:w-auto"
            ref="wrapper"
        >
            <!-- <div
                ref="leftDraggableBlock"
                class="sm:rounded-3xl overflow-hidden shadow-lg"
                :class="{
                    'h-full sm:h-auto w-full sm:w-full':
                        fullScreenView === 'model',
                    'h-full sm:h-auto w-full sm:w-2/3': fullScreenView === '',
                    'h-0 sm:h-auto w-full sm:w-0': fullScreenView === 'mesh',
                }"
            > -->
            <div
                id="modelContainer"
                ref="leftDraggableBlock"
                class="absolute top-0 left-0 w-full h-full sm:rounded-3xl overflow-hidden z-1"
            >
                <arcgis-scene
                    id="scene-model"
                    class="scene-model full h-full"
                    basemap="satellite"
                    :ground
                    :camera-position="`${finalCamera.position.longitude}, ${finalCamera.position.latitude}, ${finalCamera.position.z}`"
                    :camera-tilt="finalCamera.tilt"
                    :camera-heading="finalCamera.heading"
                    hide-attribution
                >
                    <button
                        class="sm:hidden absolute top-36 right-3 cursor-pointer bg-white/70 backdrop-blur-sm shadow rounded-lg p-2 flex justify-center items-center hover:bg-gray-100 size-10"
                        @click="toggleView('mesh')"
                    >
                        <span class="esri-icon esri-icon-basemap text-lg!" />
                    </button>
                    <!-- <button
                        slot="top-right"
                        class="hidden cursor-pointer bg-white/70 backdrop-blur-sm shadow rounded-lg p-2 sm:flex justify-center items-center hover:bg-gray-100 size-10"
                        @click="toggleView('model')"
                        :title="
                            fullScreenView === 'model'
                                ? 'Zmenšit okno'
                                : 'Zvětšit okno'
                        "
                    >
                        <span
                            class="esri-icon text-lg!"
                            :class="{
                                'esri-icon-right-triangle-arrow':
                                    fullScreenView !== 'model',
                                'esri-icon-left-triangle-arrow':
                                    fullScreenView === 'model',
                            }"
                        />
                    </button> -->

                    <!-- <arcgis-swipe
                        direction="horizontal"
                        swipe-position="75"
                    ></arcgis-swipe> -->
                </arcgis-scene>
            </div>
            <!-- Slide handle between model and mesh views -->
            <!-- <div
                ref="draggableThumb"
                class="hidden sm:flex items-center justify-center w-full sm:w-3 sm:h-full cursor-col-resize z-10"
            > -->

            <!-- <div
                ref="rightDraggableBlock"
                class="sm:rounded-3xl overflow-hidden shadow-lg"
                :class="{
                    'h-full sm:h-auto sm:w-full': fullScreenView === 'mesh',
                    'h-0 sm:h-auto sm:w-1/3': fullScreenView === '',
                    'h-0 sm:h-auto sm:w-0': fullScreenView === 'model',
                }"
            > -->

            <div
                v-if="store.isMeshLayerActivated"
                id="meshContainer"
                ref="rightDraggableBlock"
                class="absolute top-0 left-0 w-full h-full sm:rounded-3xl overflow-hidden z-10"
                style="will-change: clip-path"
            >
                <arcgis-scene
                    class="scene-mesh w-full h-full"
                    basemap="satellite"
                    :ground
                    :camera-position="`${finalCamera.position.longitude}, ${finalCamera.position.latitude}, ${finalCamera.position.z}`"
                    :camera-tilt="finalCamera.tilt"
                    :camera-heading="finalCamera.heading"
                    hide-attribution
                >
                    <button
                        class="sm:hidden absolute top-36 right-3 cursor-pointer bg-white/70 backdrop-blur-sm shadow rounded-lg p-2 flex justify-center items-center hover:bg-gray-100 size-10"
                        @click="toggleView('model')"
                    >
                        <span class="esri-icon esri-icon-basemap text-lg!" />
                    </button>
                    <div
                        class="flex gap-2"
                        slot="top-right"
                    >
                        <!-- <button
                            class="hidden cursor-pointer bg-white/70 backdrop-blur-sm shadow rounded-lg p-2 sm:flex justify-center items-center hover:bg-gray-100 size-10"
                            @click="toggleView('mesh')"
                            :title="
                                fullScreenView === 'mesh'
                                    ? 'Zmenšit okno'
                                    : 'Zvětšit okno'
                            "
                        >
                            <span
                                class="esri-icon text-lg!"
                                :class="{
                                    'esri-icon-left-triangle-arrow':
                                        fullScreenView !== 'mesh',
                                    'esri-icon-right-triangle-arrow':
                                        fullScreenView === 'mesh',
                                }"
                            />
                        </button> -->
                    </div>
                </arcgis-scene>
            </div>
            <Transition name="fade">
                <div
                    id="meshComparisonHint"
                    v-if="!store.isMeshLayerActivated"
                    class="hidden absolute top-1/2 left-full -translate-y-1/2 -translate-x-44 sm:flex items-center gap-2 px-3 py-1.5 bg-white/80 backdrop-blur-sm border border-gray-200/60 shadow-sm rounded-md text-gray-700 text-xs pointer-events-none select-none animate-[fadeInRight_.35s_ease-out] z-50 w-36"
                >
                    <div class="text-center">
                        Přetáhněte pro&nbsp;porovnání se současností
                    </div>
                    <span class="esri-icon esri-icon-right text-base" />
                </div>
            </Transition>
            <div
                ref="draggableThumb"
                class="absolute top-0 left-full -translate-x-full hidden sm:flex items-center justify-center w-full sm:w-3.5 sm:h-full cursor-col-resize z-20 bg-white backdrop-blur-sm"
                style="will-change: auto"
            >
                <div
                    class="w-14 sm:w-1.5 h-1.5 sm:h-20 bg-gray-500 rounded-full shadow-inner"
                ></div>
            </div>
        </div>
        <div class="flex justify-end w-ful text-xs pr-2">Powered by ESRI</div>
        <search-widget
            @mesh-activated-from-search="handleMeshActivationFromSearch"
        />
    </div>
</template>

<script setup lang="ts">
import SearchWidget from "./search/SearchWidget.vue"

import "@arcgis/map-components/components/arcgis-scene"
import "@arcgis/map-components/components/arcgis-swipe"

import Ground from "@arcgis/core/Ground"
import SceneLayer from "@arcgis/core/layers/SceneLayer"
import IntegratedMeshLayer from "@arcgis/core/layers/IntegratedMeshLayer"
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils"

import type SceneView from "@arcgis/core/views/SceneView"
import type Map from "@arcgis/core/Map"

import { ref, onMounted, useTemplateRef, watch } from "vue"
// import { useDraggable } from "@vueuse/core"

import { useUtils } from "../utils/utils"
import { useStore } from "../store"

// Performance optimization: RAF-based throttle for smooth animations
function rafThrottle<T extends (...args: any[]) => any>(
    func: T,
): (...args: Parameters<T>) => void {
    let rafId: number | null = null

    return (...args: Parameters<T>) => {
        if (rafId) return

        rafId = requestAnimationFrame(() => {
            func(...args)
            rafId = null
        })
    }
}

const {
    getUrlFromSources,
    getUrlFromSourcesById,
    getDefaultCamera,
    gup,
    deleteUrlParameter,
} = useUtils()
const store = useStore()

const DEFAULT_CAMERA = getDefaultCamera()

const gupLat = gup("lat")
const gupLon = gup("lon")
const gupZ = gup("z")
const gupTilt = gup("tilt")
const gupHeading = gup("heading")

const finalCamera = {
    position: {
        latitude: gupLat
            ? parseFloat(gupLat)
            : DEFAULT_CAMERA.position.latitude,
        longitude: gupLon
            ? parseFloat(gupLon)
            : DEFAULT_CAMERA.position.longitude,
        z: gupZ ? parseFloat(gupZ) : DEFAULT_CAMERA.position.z,
    },
    tilt: gupTilt ? parseFloat(gupTilt) : DEFAULT_CAMERA.tilt,
    heading: gupHeading ? parseFloat(gupHeading) : DEFAULT_CAMERA.heading,
}

deleteUrlParameter("lat")
deleteUrlParameter("lon")
deleteUrlParameter("z")
deleteUrlParameter("tilt")
deleteUrlParameter("heading")

const draggableThumb = useTemplateRef("draggableThumb")
const wrapper = useTemplateRef("wrapper")
const leftDraggableBlock = useTemplateRef("leftDraggableBlock")
const rightDraggableBlock = useTemplateRef("rightDraggableBlock")

const fullScreenView = ref<"" | "mesh" | "model">("")
/* 
useDraggable(draggableThumb, {
    onMove: event => {
        if (window.innerWidth < 640) {
            handleMobileMoveEvent(event)
        } else {
            handleMoveEvent(event)
        }
    },
})


function handleMoveEvent(event: { x: number; y: number }) {
    const container = draggableThumb.value?.parentElement
    leftDraggableBlock.value?.style.setProperty("transition", "width 0s ease")
    rightDraggableBlock.value?.style.setProperty("transition", "width 0s ease")
    if (!container) return
    fullScreenView.value = ""
    const containerRect = container.getBoundingClientRect()
    const minX = containerRect.left + 70
    const maxX = containerRect.right - 70
    let newX = event.x
    if (newX < minX) newX = minX
    if (newX > maxX) newX = maxX
    const percentage = (newX - containerRect.left) / containerRect.width
    if (leftDraggableBlock.value && rightDraggableBlock.value) {
        leftDraggableBlock.value.style.width = `${percentage * 100}%`
        rightDraggableBlock.value.style.width = `${(1 - percentage) * 100}%`
    }
}

function handleMobileMoveEvent(event: { x: number; y: number }) {
    const container = draggableThumb.value?.parentElement
    leftDraggableBlock.value?.style.setProperty("transition", "width 0s ease")
    rightDraggableBlock.value?.style.setProperty("transition", "width 0s ease")
    if (!container) return
    fullScreenView.value = ""
    const containerRect = container.getBoundingClientRect()
    const minY = containerRect.top + 70
    const maxY = containerRect.bottom - 70
    let newY = event.y
    if (newY < minY) newY = minY
    if (newY > maxY) newY = maxY
    const percentage = (newY - containerRect.top) / containerRect.height
    if (leftDraggableBlock.value && rightDraggableBlock.value) {
        leftDraggableBlock.value.style.height = `${percentage * 100}%`
        rightDraggableBlock.value.style.height = `${(1 - percentage) * 100}%`
    }
} */

function toggleView(view: "model" | "mesh") {
    store.isMeshLayerActivated = true
    if (view === fullScreenView.value) {
        fullScreenView.value = ""
        if (window.innerWidth > 640) {
            leftDraggableBlock.value?.style.setProperty(
                "transition",
                "width 0.3s ease",
            )
            rightDraggableBlock.value?.style.setProperty(
                "transition",
                "width 0.3s ease",
            )
        }
        leftDraggableBlock.value?.style.setProperty("width", "66.666%")
        rightDraggableBlock.value?.style.setProperty("width", "33.333%")
        return
    }
    fullScreenView.value = view
    if (window.innerWidth > 640) {
        leftDraggableBlock.value?.style.setProperty(
            "transition",
            "width 0.3s ease",
        )
        rightDraggableBlock.value?.style.setProperty(
            "transition",
            "width 0.3s ease",
        )
    }
    if (view === "model") {
        leftDraggableBlock.value?.style.setProperty("width", "100%")
        rightDraggableBlock.value?.style.setProperty("width", "0")
    } else {
        rightDraggableBlock.value?.style.setProperty("width", "100%")
        leftDraggableBlock.value?.style.setProperty("width", "0")
    }
}

const ground = new Ground({
    opacity: 0,
    surfaceColor: "#fff",
    layers: [],
})

const modelLayer = new SceneLayer({
    id: "langweil",
    portalItem: {
        // id: "78bf1de8f9594d7c9f77690615a42206",
        id: getUrlFromSourcesById("3d_langweil_model"),
    },
    popupEnabled: false,
})

const meshLayer = new IntegratedMeshLayer({
    id: "mesh",
    url: getUrlFromSources("3d_mesh"),
})

let active: SceneView | null = null
const views: SceneView[] = []

onMounted(() => {
    if (rightDraggableBlock.value && window.innerWidth >= 640) {
        rightDraggableBlock.value.style.clipPath = "inset(0 0 0 100%)"
    }
    draggableThumb.value?.addEventListener("mousedown", () => {
        store.isMeshLayerActivated = true
        store.isDragging = true
    })
    window.addEventListener("mouseup", () => (store.isDragging = false))

    // Performance optimization: Use RAF throttling for smooth drag
    const throttledMouseMove = rafThrottle((e: MouseEvent) => {
        if (!store.isDragging || window.innerWidth < 640) return

        const rect = wrapper.value?.getBoundingClientRect()
        if (!rect) return

        const x = Math.min(Math.max(0, e.clientX - rect.left), rect.width)

        // Use original positioning method but with RAF throttling
        if (draggableThumb.value && rightDraggableBlock.value) {
            draggableThumb.value.style.left = x + "px"
            rightDraggableBlock.value.style.clipPath = `inset(0 0 0 ${x}px)`
        }
    })

    window.addEventListener("mousemove", throttledMouseMove, { passive: true })
    const sceneModel = document.querySelector(
        ".scene-model",
    ) as HTMLArcgisSceneElement

    // const swipe = document.querySelector("arcgis-swipe")
    sceneModel?.addEventListener("arcgisViewReadyChange", () => {
        store.viewReady = true
        window.app.map = sceneModel.map as Map
        window.app.view = sceneModel.view
        sceneModel.map?.addMany([modelLayer /* , infoLayer */])
        /* const arcgisSwipe = document.querySelector("arcgis-swipe")
        if (arcgisSwipe) {
            arcgisSwipe.addEventListener("arcgisPropertyChange", e => {
                if (
                    e.detail.name === "state" &&
                    arcgisSwipe.state === "ready"
                ) {
                    arcgisSwipe.startLayers.add(modelLayer)
                    arcgisSwipe.endLayers.add(meshLayer)
                }
            })
        } */

        // sceneModel.map.addMany([modelLayer, infoLayer, budovyLayer])

        /* sceneModel.view.popup = new Popup({
            dockEnabled: true,
            dockOptions: {
                // Disables the dock button from the popup
                buttonEnabled: false,
                // Ignore the default sizes that trigger responsive docking
                breakpoint: false,
            },
        }) */

        initWatcher(sceneModel.view)

        changeShadowRootCSS()
    })
})

function handleMeshActivationFromSearch() {
    const rect = wrapper.value?.getBoundingClientRect()
    if (!rect) return
    const x = rect.width * 0.5 // Default to 75% if no position is available
    const interval = setInterval(() => {
        if (draggableThumb.value && rightDraggableBlock.value) {
            draggableThumb.value.style.left = x + "px"
            rightDraggableBlock.value.style.clipPath = `inset(0 0 0 ${x}px)`
            clearInterval(interval)
        }
    }, 50)
}

watch(
    () => store.isMeshLayerActivated,
    newValue => {
        if (newValue) {
            let interval = setInterval(() => {
                const sceneMesh = document.querySelector(
                    ".scene-mesh",
                ) as HTMLArcgisSceneElement
                if (!sceneMesh) return
                clearInterval(interval)
                window.app.viewRight = sceneMesh.view
                window.app.mapRight = sceneMesh.map as Map
                store.viewRightReady = true
                if (!sceneMesh.map) return
                sceneMesh.map.addMany([meshLayer])
                const activeViewpoint = window.app.view.viewpoint.clone()
                setTimeout(() => {
                    // Sync viewpoint to other view
                    initWatcher(sceneMesh.view)
                    window.app.viewRight.viewpoint = activeViewpoint
                }, 1000)
            }, 50)
        }
    },
)

function initWatcher(view: SceneView) {
    views.push(view)
    reactiveUtils.watch(
        () => [view.interacting, view.viewpoint, view.camera],
        ([interacting, viewpoint, camera]) => {
            // Only print the new zoom value when the view is stationary
            if (interacting) {
                active = view
                sync(active)
            }
            if (viewpoint) {
                sync(view)
            }
            if (camera) {
                sync(view)
            }
        },
    )
    reactiveUtils.watch(
        () => view.camera.position.z,
        newZ => {
            if (newZ && newZ < 190) {
                const corrected = view.camera.clone()
                corrected.position.z = 190
                view.camera = corrected
            }
        },
    )
}

function sync(source: SceneView) {
    if (!active || !active.viewpoint || active !== source) {
        return
    }

    for (const view of views) {
        if (view !== active) {
            // Clone current viewpoint
            const activeViewpoint = active.viewpoint.clone()

            // Sync viewpoint to other view
            view.viewpoint = activeViewpoint
        }
    }
}

const cssModified = ref(false)

function changeShadowRootCSS() {
    if (cssModified.value === true) return

    // Performance optimization: Use RAF instead of interval
    const applyCSS = () => {
        const rules = [
            `.esri-attribution { display: none !important; }`,
            `.esri-view { --esri-view-outline: !important; }`,
            `.esri-popup--is-docked { z-index: 50 !important; margin-top: calc(var(--spacing) * 20) !important; }`,
            `.esri-popup__main-container {
                background-color: var(--ui-bg) !important;
                border-color: var(--ui-border);
                max-height: 40vh !important;
                border-radius: var(--radius-lg);
                border-style: var(--tw-border-style);
                border-width: 1px;
                border-bottom-style: var(--tw-border-style);
                border-bottom-width: 0px;
                --tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
                box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow) !important;
            }
            @media (width >= 48rem) {
                .esri-popup__main-container {
                    max-height: 60vh;
                    border-radius: calc(var(--ui-radius) * 3);
                }
            }`,
            `.esri-widget__heading { color: var(--ui-text-highlighted); }`,
            `.esri-widget__table { color: var(--ui-text); }`,
        ]

        // Batch apply all rules at once
        rules.forEach(rule => addRule(rule))
        cssModified.value = true
    }

    // Use RAF for better timing
    requestAnimationFrame(() => {
        // Small delay to ensure scenes are ready
        setTimeout(applyCSS, 200)
    })
}

function addRule(rule: string) {
    // Performance optimization: Cache shadow root queries
    const mapElLeft = document.querySelector(
        ".scene-model",
    ) as HTMLArcgisSceneElement
    const mapElRight = document.querySelector(
        ".scene-mesh",
    ) as HTMLArcgisSceneElement

    // Apply to left scene
    if (mapElLeft?.shadowRoot) {
        const sheetLeft = mapElLeft.shadowRoot.adoptedStyleSheets[0]
        if (sheetLeft) {
            try {
                sheetLeft.insertRule(rule, sheetLeft.cssRules.length)
            } catch (e) {
                // Ignore duplicate rules
            }
        }
    }

    // Apply to right scene (if exists)
    if (mapElRight?.shadowRoot) {
        const sheetRight = mapElRight.shadowRoot.adoptedStyleSheets[0]
        if (sheetRight) {
            try {
                sheetRight.insertRule(rule, sheetRight.cssRules.length)
            } catch (e) {
                // Ignore duplicate rules
            }
        }
    }
}
</script>

<style>
@reference "../style.css";

.info-content {
    @apply flex flex-col gap-1 items-start;
    .info-content-mode-btn {
        @apply ml-auto cursor-pointer font-bold hover:text-gray-500;
    }
    &.collapsible-content {
        @apply hidden;
        &.active {
            @apply block;
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

@keyframes fadeInRight {
    from {
        opacity: 0;
        transform: translateX(-12px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>
